import "./new-vehicle-tile.scss";
import React from "react";
import { Link } from "gatsby";

const NewVehicleTile = ({ logo, name, category, thumbnail, link }) => {
  return (
    <Link to={link}>
      <div className="new-vehicle-tile">
        <div
          className="new-vehicle-tile__image"
          style={{ backgroundImage: `url(${thumbnail})` }}
        />
        <div className="new-vehicle-tile__bottom-container">
          <div className="new-vehicle-tile__logo-container">
            <img src={logo} alt={name} className="new-vehicle-tile__logo" />
          </div>
          <div className="new-vehicle-tile__category">{category}</div>
        </div>
      </div>
    </Link>
  );
};

export default NewVehicleTile;
